import React, { useState } from 'react';
import Introduction from './Introduction/Introduction';
import Gallery from './Gallery/Gallery';
import Menu from './Menu/Menu';
import Skills from './Skills/Skills';
import AboutMe from './AboutMe/AboutMe';
import Contact from './Contact/Contact';
import AppModal from './AppModal/AppModal';
import { ModalDataType } from '../common/types';

import './App.css';

const App = () => {
  const [modalData, setModalData] = useState<ModalDataType | null>(null);

  return (
    <div className='App'>
      {modalData && (
        <div
          className='modalBackdrop'
          onClick={ () => setModalData(null) }
          aria-hidden='true'
        />
      )}
      <div className={ modalData ? 'blur' : '' }>
        <Menu />
        <main className='routesWrapper'>
          <Introduction />
          <Skills />
          <Gallery setModalData={ setModalData } />
          <AboutMe />
          <Contact />
        </main>
      </div>

      <AppModal data={ modalData } setModalData={ setModalData } />
    </div>
  );
};

export default App;
